import { EChartType } from '../../models';
import { validateECSankey } from './sankey';

export const getSubType = (content): string => {
  if (content.type === EChartType.Sankey) return 'sankey';
  return 'unknown';
};

export const isSubType = (content, subType: string): boolean => {
  return getSubType(content) === subType;
};

export const validateEChart = (content) => {
  if (content.type === EChartType.Sankey) {
    validateECSankey(content);
  }
};

export class NodeGraph {
  private neighbors: Record<string, string[]>;

  constructor() {
    this.neighbors = {};
  }

  public addNode = (node: string) => {
    if (!this.neighbors[node]) {
      this.neighbors[node] = [];
    }
  };

  public addEdge = (source: string, target: string) => {
    if (!this.neighbors[source]) {
      this.addNode(source);
    }

    if (!this.neighbors[target]) {
      this.addNode(target);
    }

    this.neighbors[source].push(target);
  };

  public removeEdge = (source: string, target: string) => {
    this.neighbors[source] = this.neighbors[source].filter((node) => node !== target);
  };

  public valideEdge(source: string, target: string): boolean {
    this.addEdge(source, target);
    const res = this.calculateNodes();

    if (!res) {
      this.removeEdge(source, target);
    }

    return res;
  }

  public validate = (data: [string, string][]) => {
    return data.map((row) => this.valideEdge(row[0], row[1]));
  };

  private calculateNodes = (): boolean => {
    // Calcuate the incoming degree of each node
    const edges = Object.keys(this.neighbors);
    const inDegree = {};
    for (const edge of edges) {
      for (const neighbor of this.neighbors[edge]) {
        inDegree[neighbor] = inDegree[neighbor] + 1 || 1;
      }
    }

    // Create a queue which stores the node without dependencies
    const queue = edges.filter((edge) => !inDegree[edge]);

    let idx = 0;
    while (queue.length > 0) {
      idx++;

      // adjust the incoming degree of its neighbors
      const num = queue.shift();
      if (num) {
        for (const neighbor of this.neighbors[num]) {
          inDegree[neighbor]--;
          if (inDegree[neighbor] === 0) {
            queue.push(neighbor);
          }
        }
      }
    }

    if (idx !== edges.length) {
      return false;
    }

    return true;
  };
}
